if (!customElements.get('sc-expedition-layout')) {
  class ScExpeditionLayout extends HTMLElement {
    connectedCallback() {
      this.media = window.matchMedia('(min-width: 990px)');
      this.entries = [...this.querySelectorAll('.sc-exp__note')].map(note => {
        const marker = document.createElement('span');
        marker.hidden = true;
        note.before(marker);
        return { note, marker };
      });
      this.update = () => {
        const target = document.querySelector('.sc-exp__selection-notes');
        this.entries.forEach(({ note, marker }) => {
          if (this.media.matches && target) target.append(note);
          else marker.after(note);
        });
      };
      this.media.addEventListener('change', this.update);
      document.addEventListener('shopify:section:load', this.update);
      this.update();
    }
    disconnectedCallback() {
      this.media.removeEventListener('change', this.update);
      document.removeEventListener('shopify:section:load', this.update);
      this.entries.forEach(({ note, marker }) => {
        if (marker.parentNode) marker.after(note);
      });
    }
  }
  customElements.define('sc-expedition-layout', ScExpeditionLayout);
}
